import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ServerService} from './ServerService';

@Injectable({providedIn: 'root'})
export class PagamentosEletronicosService extends ServerService {
  constructor(http: HttpClient) {
    super(http);
  }

  obtenhaDiagnostico(ambiente?: string) {
    return this.obtenha('/pagamentos-eletronicos/connecttef/diagnostico', ambiente ? {ambiente} : {});
  }

  salveConfiguracao(configuracao: any) {
    return this.facaPut('/pagamentos-eletronicos/connecttef/configuracao', configuracao);
  }

  soliciteVinculacao() {
    return this.facaPost('/pagamentos-eletronicos/connecttef/vinculacao/qrcode', {});
  }

  listeTerminais() {
    return this.obtenha('/pagamentos-eletronicos/connecttef/terminais', {});
  }

  desativeTerminal(idTerminal: number) {
    return this.facaPut(`/pagamentos-eletronicos/connecttef/terminais/${idTerminal}/desativar`, {});
  }

  listeFormasPagamento(incluirInativos = false) {
    return this.obtenha('/pagamentos-eletronicos/connecttef/formas-pagamento',
      incluirInativos ? {incluirInativos: true} : {});
  }

  salveFormasPagamento(itens: any[]) {
    return this.facaPut('/pagamentos-eletronicos/connecttef/formas-pagamento', {itens});
  }

  persistaPagamentosComanda(idComanda: number, dados: any) {
    return this.facaPost(`/pagamentos-eletronicos/connecttef/comandas/${idComanda}/pagamentos`, dados);
  }

  listeTransacoesPedido(idPedido: number) {
    return this.obtenha(`/pagamentos-eletronicos/connecttef/pedidos/${idPedido}/transacoes`, {});
  }

  listeTransacoesComanda(idComanda: number) {
    return this.obtenha(`/pagamentos-eletronicos/connecttef/comandas/${idComanda}/transacoes`, {});
  }

  cobrePagamentoPedido(idPedido: number, idPagamento: number, idTerminal: number,
                       tipoConnectTef: number, chaveIdempotencia: string) {
    return this.facaPostCobranca(
      `/pagamentos-eletronicos/connecttef/pedidos/${idPedido}/pagamentos/${idPagamento}`,
      this.monteCobrancaSimples(idTerminal, tipoConnectTef, chaveIdempotencia)
    );
  }

  cobrePagamentoComanda(idComanda: number, idPagamento: number, idTerminal: number,
                        tipoConnectTef: number, chaveIdempotencia: string) {
    return this.facaPostCobranca(
      `/pagamentos-eletronicos/connecttef/comandas/${idComanda}/pagamentos/${idPagamento}`,
      this.monteCobrancaSimples(idTerminal, tipoConnectTef, chaveIdempotencia)
    );
  }

  obtenhaTransacao(identificacao: string) {
    return this.obtenha(
      `/pagamentos-eletronicos/connecttef/transacoes/${encodeURIComponent(identificacao)}`,
      {}
    );
  }

  listePendenciasConnectTef() {
    return this.obtenha('/pagamentos-eletronicos/connecttef/pendencias', {});
  }

  resolvaPendenciaConnectTef(identificacao: string, dados: {
    acao: string;
    justificativa: string;
    evidencia: string;
  }) {
    return this.facaPost(
      `/pagamentos-eletronicos/connecttef/transacoes/${encodeURIComponent(identificacao)}/resolver-indeterminada`,
      {
        acao: String(dados && dados.acao || '').trim(),
        justificativa: String(dados && dados.justificativa || '').trim(),
        evidencia: String(dados && dados.evidencia || '').trim(),
      }
    );
  }

  soliciteEstorno(identificacao: string, justificativa: string) {
    return this.facaPost(
      `/pagamentos-eletronicos/connecttef/transacoes/${encodeURIComponent(identificacao)}/estorno`,
      {justificativa: String(justificativa || '').trim()}
    );
  }

  private monteCobrancaSimples(idTerminal: number, tipoConnectTef: number,
                               chaveIdempotencia: string) {
    return {
      terminalId: Number(idTerminal),
      tipoConnectTef: Number(tipoConnectTef),
      parcelas: 1,
      imprimirComprovante: true,
      chaveIdempotencia,
    };
  }

  private facaPostCobranca(endpoint: string, dados: any): Promise<any> {
    return this.http.post(endpoint, dados).toPromise().then((resposta: any) => {
      if(resposta && resposta.sucesso) return resposta.data;
      return Promise.reject({definitivo: true, mensagem: resposta && resposta.erro});
    }).catch((erro: any) => {
      if(erro && erro.definitivo) return Promise.reject(erro);
      return Promise.reject({
        indeterminado: true,
        mensagem: erro && erro.message || 'Falha de comunicação durante a cobrança',
      });
    });
  }
}
